import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

export function renderRadonBlock({
  contentWidth = CONTENT_WIDTH,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) throw new Error("content is required");

  const buildings = rakennusData?.rakennukset_fulls || [];
  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const renderCellValue = value => {
    if (value === null || value === undefined || value === "") {
      return "–";
    }
    return String(value);
  };

  const createCell = (text, {
    bold = false,
    color = "black",
    fillColor
  } = {}) => ({
    text: renderCellValue(text),
    bold,
    color,
    fillColor,
    font: "Lato",
    fontSize: smallFontSize
  });

  const firstBuilding = buildings[0] || {};
  const radon = firstBuilding.aluetiedot?.radon || null;

  const postinumero =
    radon?.postinumero ??
    firstBuilding.postinumero ??
    "–";

  const alue =
    radon?.postitoimipaikka ??
    firstBuilding.toimipaikka ??
    "–";

  const radonRows = [
    {
      label: "Postinumero",
      value: postinumero
    },
    {
      label: "Alue",
      value: alue
    }
  ];

  if (radon) {
    radonRows.push(
      {
        label: "Mitattuja pientaloasuntoja",
        value: radon.mitattujaAS
      },
      {
        label: "Keskimääräinen radon",
        value:
          radon.keskiarvo !== null &&
          radon.keskiarvo !== undefined
            ? `${radon.keskiarvo} Bq/m³`
            : "–"
      },
      {
        label: "Mediaani",
        value:
          radon.mediaani !== null &&
          radon.mediaani !== undefined
            ? `${radon.mediaani} Bq/m³`
            : "–"
      },
      {
        label: "200 Bq/m³ ylitykset",
        value:
          radon.yli200 !== null &&
          radon.yli200 !== undefined
            ? `${radon.yli200} %`
            : "–"
      },
      {
        label: "300 Bq/m³ ylitykset",
        value:
          radon.yli300 !== null &&
          radon.yli300 !== undefined
            ? `${radon.yli300} %`
            : "–"
      },
      {
        label: "1000 Bq/m³ ylitykset",
        value:
          radon.yli1000 !== null &&
          radon.yli1000 !== undefined
            ? `${radon.yli1000} %`
            : "–"
      }
    );
  } else {
    radonRows.push({
      label: "Mittaustiedot",
      value: "Ei mitattuja radonarvoja alueella."
    });
  }

  const body = [
    [
      createCell("Alueen radonarvot", {
        bold: true,
        color: WHITE,
        fillColor: GREEN
      }),
      createCell("Arvo", {
        bold: true,
        color: WHITE,
        fillColor: GREEN
      })
    ]
  ];

  radonRows.forEach((row, index) => {
    const fillColor =
      index % 2 === 0
        ? LIGHT_GREY
        : WHITE;

    body.push([
      createCell(row.label, { fillColor }),
      createCell(row.value, { fillColor })
    ]);
  });

  const TABLE_WIDTH = contentWidth * 0.92;

  content.push({
    table: {
      widths: [
        TABLE_WIDTH * 0.47,
        TABLE_WIDTH * 0.58
      ],
      body
    },
    layout: {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingLeft: () => 4,
      paddingRight: () => 4,
      paddingTop: () => 4,
      paddingBottom: () => 4,
      dontBreakRows: false
    },
    margin: [
  0,
  0,
  0,
  bottomMarginItemGlobal
]
  });
}